import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useForm from 'shared/hooks/useForm';
import { isEmailValid, isStringValid } from 'shared/lib/validators';
import { Input, Submit } from 'shared/components/Form';
import styles from './Form.module.scss';

const LoginForm = ({ onSubmit, processing, className }) => {
  const { t } = useTranslation('common');

  const validate = (data = {}) => {
    const errors = {};

    if (!isEmailValid(data.username)) {
      errors.username = t('common:validation.fillValidEmail');
    }

    if (!isStringValid(data.password)) {
      errors.password = t('common:validation.fillPassword');
    }

    return errors;
  };

  const { values, handleChange, handleSubmit, errors, hasError } = useForm(onSubmit, {
    username: '',
    password: ''
  }, validate);

  return (
    <form className={cn(styles.login, className)} onSubmit={handleSubmit} autoComplete="off">
      <Input
        autoComplete="off"
        error={errors.username}
        iconClass="la la-user"
        name="username"
        value={values.username}
        type="email"
        onChange={handleChange}
        label={t('form.email')}
      />
      <Input
        autoComplete="off"
        error={errors.password}
        iconClass="la la-key"
        name="password"
        value={values.password}
        type="password"
        onChange={handleChange}
        label={t('form.password')}
      />
      <div className="centerMd">
        <Submit
          title={t('button.login')}
          disabled={hasError}
          onClick={handleSubmit}
          processing={processing}
        />
      </div>
    </form>
  );
};

LoginForm.propTypes = {
  onSubmit: PropTypes.func,
  processing: PropTypes.bool
};

LoginForm.defaultProps = {
  onSubmit() {},
  processing: false
};

export default LoginForm;
